/** @format */

import React,{useContext,useEffect,useState,useRef} from 'react'
import {Outlet,useNavigate} from 'react-router-dom'
import Footer from '../components/Nav/Footer'
import UserContext from '../contexts/UserContext'
import {setAnalyticsCollectionEnabled,setUserId} from 'firebase/analytics'
import analytics from '../helpers/analytics'
import Loading from '../pages/Loading'

export default function Guest({children,accessible=false,footer=accessible,fullWidth=false,...props}) {
  let navigate=useNavigate()
  const [user,loading]=useContext(UserContext)

  useEffect(() => {
    if(!accessible) {
      if(user&&!loading) {
        navigate('/dashboard')
      }
    }
    if(user) {
      setUserId(analytics,user.uid)
    }

  },[user,navigate,accessible,loading])

  if(loading) {
    return <Loading />
  }

  return (
    <div className={`min-h-full px-4 pb-10 mx-auto font-enwrite ${fullWidth? 'w-full':'max-w-7xl'}`}>
      <Outlet />
      {footer? <Footer />:null}
    </div>
  )
}
